import { render, staticRenderFns } from "./gj-tree-select.vue?vue&type=template&id=13512332&scoped=true&"
import script from "./gj-tree-select.vue?vue&type=script&lang=js&"
export * from "./gj-tree-select.vue?vue&type=script&lang=js&"
import style0 from "./gj-tree-select.vue?vue&type=style&index=0&id=13512332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13512332",
  null
  
)

export default component.exports